<sc-paged-content [data]="data" [configuration]="configuration" (addRequested)="onAddRequested($event)"
  (selectionChanged)="onSelectionChanged($event)" [selected]="[currentTheme]">
  <sc-no-data-container [hasData]="currentTheme" fitHeight>
    <sc-flex vertical fitHeight stretchContent>
      <sc-flex [gap]="16">
        <sc-cancel-button (click)="cancelEditing()"></sc-cancel-button>
        <sc-save-button (click)="saveTheme()" primary></sc-save-button>
        <sc-content-spacer grow></sc-content-spacer>
        @if (showDetails){
        <sc-action-icon iconClass="fa-eye" (click)="switchDetailMode()"></sc-action-icon>
        }
        @if (!showDetails){
        <sc-action-icon iconClass="fa-eye-slash" (click)="switchDetailMode()"></sc-action-icon>
        }
      </sc-flex>
      <sc-content-spacer vertical></sc-content-spacer>
      <sc-formular-component [model]="currentTheme"
        [context]="{layout: detailLayout!, detailLayoutItemProvider: detailLayoutItemProvider!}"></sc-formular-component>
      <sc-content-spacer vertical></sc-content-spacer>
      <sc-flex-fitting-content vertical>
        <sc-scroll-pane>
          <sc-flex vertical stretchContent cdkDropList [gap]="16" (cdkDropListDropped)="drop($event)">
            @for (rule of currentTheme?.transportColoringRule; track $index) {
            <yard-transport-visualization-rule cdkDrag [rule]="rule" (deleteRule)="onDeleteRule($event)" (editRule)="onEditRule($event)" [showDetails]="showDetails"></yard-transport-visualization-rule>
            }
          </sc-flex>
        </sc-scroll-pane>
      </sc-flex-fitting-content>
      <sc-content-spacer vertical></sc-content-spacer>
      <sc-flex centered>
        <sc-add-action-button large (click)="addRule()"></sc-add-action-button>
      </sc-flex>
    </sc-flex>
  </sc-no-data-container>
</sc-paged-content>
